import React, { useState, useEffect, useContext, useMemo } from 'react';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';
import { DynamicModalContext } from '../../../init/dynamicModals';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button, Switch } from 'antd';

import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/creatable';

import toast from 'react-hot-toast';
import KeyPad from '../../../components/keyPad/keyPad';
import { FaUserPlus } from "react-icons/fa6";

import Loader from '../../../components/loader/loader';
import CustomerForm from '../../../salesTab/customer/customerForm';

import { numberFormatter } from '../../../components/formatters/numberFormatter';


function CustomerModal(props) {

  const { showModal, toggleModal, title, selectedTab, } = props;

  const { settingData, customerAccountData, rateMainToSecondaryCurrency, rateToMainCurrency, defaultCurrency, rateSecondaryToMainCurrency,
    refData, companyId, customerAccountOptions, loadCustomerAccountOptions, isUsingMainCurrency } = useContext(DataContext);

  const { tabData, setTabData, setJournalVoucher } = useContext(PosCartContext);
  const { openAddCustomerModal, addedCustomer, setAddedCustomer } = useContext(DynamicModalContext);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);



  const cart = tabData[selectedTab].cart;
  const journalVoucher = tabData[selectedTab].journalVoucher;



  useEffect(() => {
    setInputValue("");
  }, [showModal]);


  useEffect(() => {
    console.log('Added Customer:', addedCustomer);
    if (addedCustomer) {
      let updatedJv = { ...journalVoucher };
      updatedJv.accountId = addedCustomer.id;
      setJournalVoucher(updatedJv, selectedTab)

      // ✅ add new option into the options list if not already there
      const exists = customerAccountOptions?.some(opt => opt.value === addedCustomer.id);
      if (!exists) {
        customerAccountOptions.push({
        value: addedCustomer.id,
        label:
          addedCustomer.accountId + '. ' +
          addedCustomer.english +
          (addedCustomer.phone ? ' [' + addedCustomer.phone + ']' : '') +
          (addedCustomer.registration ? ' (' + addedCustomer.registration + ')' : ''),


        });  
      }
    } 

  }, [addedCustomer]);


  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    let updatedJv = { ...journalVoucher };
    updatedJv.accountId = selectedOption?.value || null;

    setJournalVoucher(updatedJv, selectedTab)
    if (selectedOption == null) {
      setAddedCustomer(null);
    }
  };

  const closeModal = () => {

    toggleModal();
  }



  const selectedCustomer = useMemo(
    () => customerAccountOptions?.find(option => option.value === journalVoucher.accountId),
    [customerAccountOptions, journalVoucher.accountId, addedCustomer]
  );

  const handleSwitch = (value) => {
    let updatedJv = { ...journalVoucher };

    if (value == false) {
      updatedJv.pointsValue = 0;
      updatedJv.secondaryPointsValue = 0;
    }
    updatedJv.isUsingPoints = value || false;
    setJournalVoucher(updatedJv, selectedTab)
  }

  const handleInput = (e) => {
    let updatedJv = { ...journalVoucher };

    const maxValue = isUsingMainCurrency ? selectedCustomer?.points : selectedCustomer?.secondaryPoints;

    const pointsValueInput = e.target.value;

    const pointsValue = isUsingMainCurrency ? pointsValueInput : rateSecondaryToMainCurrency(pointsValueInput);
    const secondaryPointsValue = isUsingMainCurrency ? rateMainToSecondaryCurrency(pointsValueInput) : pointsValueInput;

    const usedPoints = pointsValue / selectedCustomer?.equation;
    const secondaryUsedPoints = secondaryPointsValue / selectedCustomer?.equation;

    updatedJv.pointsValue = pointsValue;
    updatedJv.secondaryPointsValue = secondaryPointsValue;
    updatedJv.usedPoints = usedPoints;
    updatedJv.secondaryUsedPoints = secondaryUsedPoints;

    setJournalVoucher(updatedJv, selectedTab)
  }


  return (
    <Modal show={showModal} onHide={toggleModal} backdrop='static'>
      <Modal.Header style={{ background: "#1d7790" }}>
        <Modal.Title style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        {isLoading &&
          <Loader />
        }

        {!isLoading &&
          <>
            <Row className="mb-4" style={{ marginTop: '4vh' }}>

              <Col>
                <AsyncSelect
                  cacheOptions
                  isClearable={true}
                  loadOptions={loadCustomerAccountOptions}
                  defaultOptions={[]}
                  onChange={(e) => handleSelectChange(e, 'accountId')}
                  value={selectedCustomer}
                  noOptionsMessage={() => 'type to view'}
                  autoFocus
                  onKeyDown={(e) => { if (e.key === 'Enter') { closeModal() } }}
                />
              </Col>

              <Col md={2}>
                <FaUserPlus size={30} style={{ cursor: 'pointer' }} onClick={openAddCustomerModal} />
              </Col>

            </Row> 

            
          
{settingData?.useLoyalityPoint && selectedCustomer && (
  <Card className="mt-4 border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
    <Card.Body className="p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-0 text-muted" style={{ fontSize: '0.9rem', fontWeight: '600' }}>
          LOYALTY PROGRAM
        </h6>
        <div className="d-flex align-items-center">
          <span className="me-2 text-muted" style={{ fontSize: '0.85rem' }}>Use Points</span>
          <Switch
            style={{
              backgroundColor: journalVoucher?.isUsingPoints ? '#1d7790' : '#bebfbe',
            }}
            checked={journalVoucher?.isUsingPoints}
            onChange={(e) => handleSwitch(e)}
          />
        </div>
      </div>

      <Row className="g-2">
        {/* Tier/Type Badge */}
        <Col xs={4}>
          <div className="p-2 text-center" style={{ background: '#fff', borderRadius: '8px', border: '1px solid #eee' }}>
            <div className="text-muted small">Tier</div>
            <div className="fw-bold text-dark">{selectedCustomer?.loyaltyType || 'Standard'}</div>
          </div>
        </Col>

        {/* Total Points */}
        <Col xs={4}>
          <div className="p-2 text-center" style={{ background: '#fff', borderRadius: '8px', border: '1px solid #eee' }}>
            <div className="text-muted small">Points</div>
            <div className="fw-bold text-primary">
              {numberFormatter(isUsingMainCurrency ? selectedCustomer?.totalPoints : selectedCustomer?.secondaryTotalPoints)}
            </div>
          </div>
        </Col>

        {/* Cash Value */}
        <Col xs={4}>
          <div className="p-2 text-center" style={{ background: '#fff', borderRadius: '8px', border: '1px solid #eee' }}>
            <div className="text-muted small">Value</div>
            <div className="fw-bold text-success">
              {numberFormatter(isUsingMainCurrency ? selectedCustomer?.pointsValue : selectedCustomer?.secondaryPointsValue)}
            </div>
          </div>
        </Col>
      </Row>

      {journalVoucher?.isUsingPoints && (
        <div className="mt-3 animate__animated animate__fadeIn">
          <Form.Label className="small fw-bold text-muted">Redeem Amount</Form.Label>
          <InputGroup className="shadow-sm">
            <InputGroup.Text style={{ backgroundColor: '#1d7790', color: 'white' }}>$</InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="form-control-lg"
              style={{ fontSize: '1.1rem', fontWeight: '500' }}
              onChange={(e) => handleInput(e)}
              value={isUsingMainCurrency ? journalVoucher?.pointsValue : journalVoucher?.secondaryPointsValue}
              placeholder="0.00"
            />
          </InputGroup>
          <Form.Text className="text-muted">
            Max available: {numberFormatter(isUsingMainCurrency ? selectedCustomer?.pointsValue : selectedCustomer?.secondaryPointsValue)}
          </Form.Text>
        </div>
      )}
    </Card.Body>
  </Card>
)}

          </>
        }
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button type="primary" size="large" loading={loadingEffect} onClick={closeModal}
            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }} danger>Done</Button>
        </div>
      </Modal.Footer>

    </Modal>  

  );
}

export default CustomerModal;
